<template>
    <div style="background-color: #f2f2f2;height: 100%;" class="doctorPage">
        <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
            医生就诊列表
        </div>
        <div style="padding: 20px;">

            <div>

                <el-row>
                    <el-button @click.native="toggleModalWaitingDoctor">接诊患者</el-button>
                    <el-button @click.native="toggleModalMedicalRecord">查询就诊记录</el-button>
                    <el-button @click.native="toggleModalAdd">添加检查处方</el-button>
                    <el-button @click.native="toggleModalPrescribe">添加药品处方</el-button>
                    <el-button @click.native="toggleModalAddTreat">添加治疗处方</el-button>
                    <el-button @click.native="seeResults">填写就诊结果</el-button>
                    <el-button @click.native="handleSuccess">就诊完成</el-button>
                </el-row>

                <div style="clear: both;"></div>
            </div>

            <div style="height: 10px;"></div>

            <div>
                <el-card class="box-card" shadow="hover" style="margin-bottom: 10px">
                    <div slot="header" class="clearfix">
                        <span>就诊中患者</span>
                    </div>
                    <template>
                        <el-table :data="tableData" border style="width: 100%;" empty-text='暂未接诊患者'>
                            <el-table-column prop="register.serialNumber" width="320" label="编号"></el-table-column>
                            <el-table-column prop="patient.name" label="患者姓名"></el-table-column>
                            <el-table-column prop="register.price" label="挂号费"></el-table-column>
                            <el-table-column
                                    prop="register.status"
                                    :formatter="statusTitle"
                                    label="状态">
                            </el-table-column>
                            <el-table-column
                                    prop="register.visitType"
                                    :formatter="visitTypeTitle"
                                    label="就诊类型">
                            </el-table-column>
                        </el-table>
                    </template>
                </el-card>
                <el-card class="box-card" shadow="hover">
                    <div slot="header" class="clearfix">
                        <span>就诊记录</span>
                    </div>
                    <template>
                        <el-table :data="tableData" :height="th" border style="width: 100%;" empty-text='暂无就诊记录'>
                            <el-table-column prop="serialNumber" label="编号"></el-table-column>
                            <el-table-column prop="patientName" label="患者姓名"></el-table-column>
                            <el-table-column prop="departmentDrugName" label="就诊部门"></el-table-column>
                            <el-table-column prop="medicinerName" label="医生"></el-table-column>
                            <el-table-column prop="price" label="挂号费"></el-table-column>
                            <el-table-column
                                    prop="status"
                                    :formatter="statusTitle"
                                    label="状态">
                            </el-table-column>
                            <el-table-column
                                    prop="visitType"
                                    :formatter="visitTypeTitle"
                                    label="就诊类型">
                            </el-table-column>
                        </el-table>
                    </template>
                    <div style="text-align: left;background-color: #fff;padding: 10px;">
                        <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                        <div style="float: left;">
                            <el-pagination
                                    background
                                    layout="prev, pager, next"
                                    :total="totalItems"
                                    :page-size="20"
                                    @current-change="current_change">
                            </el-pagination>
                        </div>
                        <div style="clear: both;"></div>
                    </div>
                </el-card>
            </div>

        </div>

        <Add ref="myAdd" v-show="showModalAdd" v-bind:inspectionItemList="inspectionItemList" v-on:closeAdd="closeAdd" v-on:getList="getList"></Add>
        <AddTreat ref="myAddTreat" v-show="showModalAddTreat" v-bind:treatmentItemList="treatmentItemList" v-on:closeAddTreat="showModalAddTreat=false" v-on:getList="getList"></AddTreat>
        <Prescribe ref="myPrescribe" v-show="showModalPrescribe" v-bind:inspectionItemList="inspectionItemList" v-on:closePrescribe="closePrescribe" v-on:getList="getList"></Prescribe>
        <Edit ref="myEdit" v-show="showModalEdit" v-on:closeEdit="closeEdit" v-on:getList="getList"></Edit>
        <Info ref="myInfo" v-show="showModalInfo" v-on:closeInfo="closeInfo" v-on:getList="getList"></Info>
        <WaitingDoctor ref="myWaitingDoctor" v-show="showModalWaitingDoctor" v-on:closeWaitingDoctor="closeWaitingDoctor" v-on:getList="getList"></WaitingDoctor>
        <MedicalRecord ref="myMedicalRecord" v-show="showModalMedicalRecord" v-on:closeMedicalRecord="showModalMedicalRecord=false" v-on:getList="getList"></MedicalRecord>

    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";

    import Edit from "./Edit";
    import Add from "./Add";
    import AddTreat from "./AddTreatment";
    import Info from "./Info";
    import Prescribe from "./Prescribe";
    import MedicalRecord from "./MedicalRecord";
    import WaitingDoctor from "./WaitingDoctor";
    import {getStaffCode} from "@/utils/auth";

    export default {
        name: "Role",
        data(){
            return{
                loading:false,
                showModalAdd:false,
                showModalPrescribe:false,
                showModalEdit:false,
                showModalInfo:false,
                showModalAddTreat:false,
                showModalWaitingDoctor:false,
                disabledAccepts:false,
                disabledAdd:false,
                showModalMedicalRecord:false,
                disabledSuccess:false,
                disabledInfo:false,
                tableData:[],
                inspectionItemList:[],
                treatmentItemList:[],
                status:0,
                type:-1,
                visitTypeValue:[
                    {
                        val:-1,
                        name:'就诊类型'
                    },
                    {
                        val:1,
                        name:'初诊'
                    },
                    {
                        val:2,
                        name:'复诊'
                    },
                ],
                statusValue:[
                    {
                        val:-1,
                        name:'全部状态'
                    },{
                        val:1,
                        name:'已挂号'
                    },{
                        val:2,
                        name:'待诊中'
                    },{
                        val:3,
                        name:'诊疗中'
                    },{
                        val:4,
                        name:'已诊疗'
                    },{
                        val:11,
                        name:'作废'
                    }
                ],
                totalItems: 0,
                name: '',
                pageSize:20,
                currentPage:1,
                th:0,

            }
        },
        components:{
            Add,Edit,WaitingDoctor,Info,Prescribe,AddTreat,MedicalRecord
        },
        created(){
            this.init();
            this.getList();
            this.th = this.$store.state.tableHeight-320;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                console.log(val);
                this.th = val;
            },
        },
        methods:{
            init(){
                this.getInspectionItemList()
                this.getTreatmentItemList()
            },
            getInspectionItemList(){
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"InspectionItem/List",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                    }
                }).then( (response)=> {
                    if(response.data.error == 0){
                        this.inspectionItemList = response.data.data;
                    }else if(response.data.error == 1){
                        this.$message({type: 'info', message: response.data.message});
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            getTreatmentItemList(){
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"TreatmentItem/List",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                    }
                }).then( (response)=> {
                    if(response.data.error == 0){
                        this.treatmentItemList = response.data.data;
                    }else if(response.data.error == 1){
                        this.$message({type: 'info', message: response.data.message});
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            handleSuccess() {
                if(this.tableData.length==0){
                    this.$message.error('暂无就诊中患者')
                    return;
                }
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"CureFlow/VisitFinish",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        registerCode:this.tableData[0].registerCode,
                    }
                }).then( (response)=> {
                    if(response.data.error == 0){
                        this.getList();
                    }else if(response.data.error == 1){
                        this.$message({type: 'info', message: response.data.message});
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            toggleModalAdd:function(){
                if(this.tableData.length==0){
                    this.$message.error('暂无就诊中患者')
                    return;
                }
                this.showModalAdd = !this.showModalAdd;
                this.$refs.myAdd.init(this.tableData[0].consultationRecordCode);
            },
            toggleModalAddTreat:function(){
                if(this.tableData.length==0){
                    this.$message.error('暂无就诊中患者')
                    return;
                }
                this.showModalAddTreat = !this.showModalAddTreat;
                this.$refs.myAddTreat.init(this.tableData[0].consultationRecordCode);
            },
            toggleModalPrescribe:function(){
                if(this.tableData.length==0){
                    this.$message.error('暂无就诊中患者')
                    return;
                }
                this.showModalPrescribe = !this.showModalPrescribe;
                this.$refs.myPrescribe.init(this.tableData[0].consultationRecordCode);
            },
            toggleModalInfo:function(){
                this.showModalInfo = !this.showModalInfo;
                this.$refs.myInfo.init();
            },
            toggleModalWaitingDoctor:function(){
                this.showModalWaitingDoctor = !this.showModalWaitingDoctor;
                this.$refs.myWaitingDoctor.init();
            },
            toggleModalMedicalRecord(){
                this.showModalMedicalRecord =true;
                this.$refs.myMedicalRecord.init();
            },
            closeAdd:function(){
                this.showModalAdd = !this.showModalAdd;
            },
            closePrescribe:function(){
                this.showModalPrescribe = !this.showModalPrescribe;
            },
            closeInfo:function(){
                this.showModalInfo = !this.showModalInfo;
            },
            toggleModalEdit:function(){
                this.showModalEdit = !this.showModalEdit;
            },
            closeEdit:function(){
                this.showModalEdit = !this.showModalEdit;
            },
            closeWaitingDoctor:function(){
                this.showModalWaitingDoctor = !this.showModalWaitingDoctor;
            },
            seeResults(){
                this.$prompt('请输入就诊结果', '就诊结果', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputType:'textarea'
                }).then(({ value }) => {
                    if(value){
                        this.$axios({
                            method: 'post',
                            url: this.$institutionUrl+"ConsultationRecord/updateFeeResult",
                            data: {
                                timeStr:timeStr,
                                sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                                staffCode: getStaffCode(),
                                consultationRecordCode:this.tableData[0].consultationRecordCode,
                                opinion:value
                            }
                        }).then( (response)=> {
                            if(response.data.error == 0){
                                this.$message.success('添加成功')
                            }else if(response.data.error == 1){
                                this.$message({type: 'info', message: response.data.message});
                            }
                        }).catch(function (error) {
                            console.log(error);
                        });
                    }else{
                        this.$message.error('就诊结果不能为空，添加失败')
                    }
                   
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '取消输入'
                    });       
                });
            },
            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },

            getList(){
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"Register/Underway",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode()
                    }
                }).then( (response)=> {
                    if(response.data.error == 0){
                        this.tableData=[]
                        if(response.data.data){
                            this.tableData.push(response.data.data)
                        }
                    }else if(response.data.error == 1){
                        this.$message({type: 'info', message: response.data.message});
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            statusTitle(row,index,column){
                for(var i in this.statusValue){
                    if(this.statusValue[i].val==column){
                        return this.statusValue[i].name
                    }
                }
                return "其它";
            },
            visitTypeTitle(row,index,column){
                for(var i in this.visitTypeValue){
                    if(this.visitTypeValue[i].val==column){
                        return this.visitTypeValue[i].name
                    }
                }
                return "其它";
            },
        }
    }
</script>

<style lang="scss" scoped>
    // .doctorPage .box-card{
    //     margin-bottom: 10px;
    // }
</style>
